var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{ref:"editor",tag:"component",attrs:{"mode":"activity","value":_vm.value,"view":_vm.view,"activityState":_vm.activityState},on:{"update:view":function($event){_vm.view=$event},"update:activityState":function($event){_vm.activityState=$event},"update:activity-state":function($event){_vm.activityState=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }